<template>
  <div>
    <v-toolbar color="primary" tabs dark fixed app>
      <v-toolbar-side-icon @click="handleSidebar">
        <v-icon>menu</v-icon>
      </v-toolbar-side-icon>

      <v-autocomplete
        flat
        solo-inverted
        attach
        hide-details
        append-icon="search"
        label="Cari Training"
        class="hidden-xs-only"
        item-text="materi"
        item-value="id_training"
        no-data-text="Kata kunci tidak ditemukan."
        :filter="searchFilter"
        :items="training"
        @change="detailTraining"
        v-model="id_training"
      >
        <template slot="item" slot-scope="data">
          <v-list-tile-avatar>
            <img
              v-lazy="c.PHOTO_TRAINING_URL + defaultPhoto(data.item.photos)"
              :alt="`Photo-${data.item.id_training}`"
            />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{
              data.item.materi | truncate({ length: 30 })
            }}</v-list-tile-title>
            <v-list-tile-sub-title>
              <v-chip small>{{
                data.item.waktu_mulai | moment("from", "now")
              }}</v-chip>
              {{ data.item.client_grouped | truncate({ length: 50 }) }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </v-autocomplete>

      <v-spacer></v-spacer>
      <!-- fullscreen handler -->
      <v-btn icon @click="handleFullScreen()">
        <v-icon>{{ fullscreenIcon }}</v-icon>
      </v-btn>
      <!-- list menu -->
      <v-menu
        offset-y
        origin="top right"
        :nudge-bottom="$vuetify.breakpoint.smAndDown ? 12 : 14"
        :nudge-left="$vuetify.breakpoint.smAndDown ? 90 : 80"
        attach
        transition="scale-transition"
      >
        <v-btn icon large flat slot="activator">
          <v-avatar size="30" class="thumbnail">
            <img
              :src="c.PHOTO_PROFIL_URL + profil.photo_profil"
              :alt="profil.username"
            />
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile to="/profil" ripple>
            <v-list-tile-action>
              <v-icon>account_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Profil</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="handleRightSidebar" ripple>
            <v-list-tile-action>
              <v-icon>palette</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Tema</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout" ripple>
            <v-list-tile-action>
              <v-icon>power_settings_new</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <!-- Theme Setting (Right Sidebar) -->
    <app-theme-settings> </app-theme-settings>
  </div>
</template>

<script>
import _ from "lodash";
import Util from "@/util";
import c from "@/constants";
import AppThemeSettings from "@/components/app/AppThemeSettings";
import { mapState, mapGetters } from "vuex";

export default {
  name: "app-toolbar",
  components: {
    AppThemeSettings
  },
  data: () => ({
    fullscreen: false,
    id_training: "",
    c: c
  }),
  computed: {
    ...mapState(["ui"]),
    ...mapState("auth", ["profil"]),
    ...mapGetters("training", ["trainingByLaman"]),
    training() {
      let training = this.trainingByLaman;
      for (let i = 0; i < training.length; i++) {
        training[i].client_grouped = training[i].clients
          .map(c => c.client)
          .join(", ");
      }
      return _.orderBy(training, "waktu_mulai", "desc");
    },
    fullscreenIcon() {
      return this.fullscreen ? "fullscreen_exit" : "fullscreen";
    }
  },
  methods: {
    searchFilter(item, query) {
      let bool = false;
      if (query.length > 1) {
        if (item.materi.indexOf(query.toUpperCase()) > -1) {
          bool = true;
        }
        for (let i = 0; i < item.clients.length; i++) {
          if (item.clients[i].client.indexOf(query.toUpperCase()) > -1) {
            bool = true;
          }
        }
      }
      return bool;
    },
    detailTraining() {
      if (this.id_training) {
        this.$router.push({
          name: "TrainingList",
          query: { id: this.id_training }
        });
      }
    },
    defaultPhoto(photos) {
      let photo_kegiatan = photos.filter(p => p.pel_photo_tipe == "KEGIATAN");
      if (photo_kegiatan.length) return photo_kegiatan[0].pel_photo;
      else return "no-image.png";
    },
    logout() {
      this.$store.dispatch("auth/LOGOUT").then(() => {
        this.$router.push("/");
        this.$store.commit("INFO", "Sampai jumpa lagi..");
      });
    },
    handleSidebar() {
      this.$store.dispatch("SET_SIDEBAR", !this.ui.sidebar);
    },
    handleRightSidebar() {
      this.$store.commit("SET_RIGHT_SIDEBAR", true);
    },
    handleFullScreen() {
      this.fullscreen = !this.fullscreen;
      Util.toggleFullScreen();
    }
  },
  mounted() {
    this.$store.dispatch("training/GET_TRAINING");
  }
};
</script>
